module.exports = __webpack_public_path__ + "img/np_shark_3583713_F0CD5E.a2f0be43.svg";